import src from "IMAGE";
export default { src, width: 956, height: 956, blurWidth: 0, blurHeight: 0};
